import React, { useState } from 'react';
import { ChevronRightIcon, CreditCardIcon, BellIcon, CoinsIcon, GlobeIcon, HelpCircleIcon, GiftIcon, FileTextIcon, SettingsIcon, CalendarIcon, StarIcon, LogOutIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { Button } from '../components/Button';
export function ProfileScreen() {
  const navigate = useNavigate();
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to log out?')) {
      navigate('/profile/logged-out');
    }
  };
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-662">
      {/* Header with gradient */}
      <div className="bg-gradient-to-br from-[#1f5070] to-[#3dc7e3] px-6 py-6" data-id="element-663">
        <div className="flex items-center justify-between mb-4" data-id="element-664">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-8 object-contain brightness-0 invert" data-id="element-665" />
          <button onClick={() => alert('Settings coming soon!')} className="p-2 hover:bg-white/10 rounded-full active:scale-95 transition-all" data-id="element-666">
            <SettingsIcon className="w-6 h-6 text-white" data-id="element-667" />
          </button>
        </div>

        {/* User section */}
        <div className="text-center" data-id="element-668">
          <div className="w-20 h-20 mx-auto mb-3 bg-[#c7f61e] rounded-full flex items-center justify-center" data-id="element-669">
            <span className="text-3xl font-bold text-[#1f5070]" data-id="element-670">JW</span>
          </div>
          <h2 className="text-xl font-bold text-white mb-1" data-id="element-671">Jabbar</h2>
          <p className="text-sm text-white/80 mb-3" data-id="element-672">jabbar@jwventures.group</p>
          <button onClick={() => setShowEditProfile(true)} className="px-4 py-2 border-2 border-white text-white rounded-lg text-sm font-bold hover:bg-white/10 active:scale-95 transition-all" data-id="element-673">
            Edit Profile
          </button>
        </div>
      </div>

      {/* Stats cards */}
      <div className="grid grid-cols-3 gap-3 px-4 -mt-6 mb-4" data-id="element-674">
        <button onClick={() => navigate('/bookings/populated')} className="bg-white rounded-xl shadow-md p-3 text-center active:scale-95 transition-transform" data-id="element-675">
          <CalendarIcon className="w-6 h-6 text-[#c7f61e] mx-auto mb-1" data-id="element-676" />
          <p className="text-lg font-bold text-[#1f5070]" data-id="element-677">12</p>
          <p className="text-xs text-[#666666]" data-id="element-678">Bookings</p>
        </button>
        <button onClick={() => alert('Credits: 500 UC\n\nYou can use your UniPlay Credits to book courts and get exclusive discounts!')} className="bg-white rounded-xl shadow-md p-3 text-center active:scale-95 transition-transform" data-id="element-679">
          <CoinsIcon className="w-6 h-6 text-[#c7f61e] mx-auto mb-1" data-id="element-680" />
          <p className="text-lg font-bold text-[#1f5070]" data-id="element-681">500</p>
          <p className="text-xs text-[#666666]" data-id="element-682">UC</p>
        </button>
        <button onClick={() => alert('Member Status: Active\n\nEnjoy exclusive benefits and priority booking!')} className="bg-white rounded-xl shadow-md p-3 text-center active:scale-95 transition-transform" data-id="element-683">
          <StarIcon className="w-6 h-6 text-[#3dc7e3] mx-auto mb-1" data-id="element-684" />
          <p className="text-lg font-bold text-[#1f5070]" data-id="element-685">Member</p>
          <p className="text-xs text-[#666666]" data-id="element-686">Status</p>
        </button>
      </div>

      <div className="flex-1 overflow-auto px-4 pb-4 space-y-4" data-id="element-687">
        {/* Account section */}
        <div className="space-y-2" data-id="element-688">
          <h3 className="text-sm font-bold text-[#666666] px-2 mb-2" data-id="element-689">
            ACCOUNT
          </h3>

          <button onClick={() => alert('Payment Methods\n\n• Visa •••• 1234\n• UniPlay Credits: 500 UC\n\nAdd or manage your payment methods here.')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-690">
            <CreditCardIcon className="w-5 h-5 text-[#666666]" data-id="element-691" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-692">
              Payment Methods
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-693" />
          </button>

          <div className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3" data-id="element-694">
            <BellIcon className="w-5 h-5 text-[#666666]" data-id="element-695" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-696">
              Notifications
            </span>
            <button onClick={() => {
            setNotificationsEnabled(!notificationsEnabled);
            setTimeout(() => {
              alert(notificationsEnabled ? 'Notifications disabled' : 'Notifications enabled');
            }, 100);
          }} className={`relative w-12 h-7 rounded-full transition-colors ${notificationsEnabled ? 'bg-[#3dc7e3]' : 'bg-gray-300'}`} data-id="element-697">
              <div className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-md transition-transform ${notificationsEnabled ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-698" />
            </button>
          </div>

          <button onClick={() => setShowLanguageModal(true)} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-699">
            <GlobeIcon className="w-5 h-5 text-[#666666]" data-id="element-700" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-701">
              Language
            </span>
            <span className="text-sm text-[#666666]" data-id="element-702">English</span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-703" />
          </button>
        </div>

        {/* Credits section */}
        <div className="space-y-2" data-id="element-704">
          <h3 className="text-sm font-bold text-[#666666] px-2 mb-2" data-id="element-705">
            CREDITS
          </h3>

          <button onClick={() => alert('My UniPlay Credits\n\nCurrent Balance: 500 UC\n\nUse your credits to book courts and get 5% loyalty discount on all bookings!')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-706">
            <CoinsIcon className="w-5 h-5 text-[#c7f61e]" data-id="element-707" />
            <div className="flex-1 text-left" data-id="element-708">
              <p className="text-[#1f5070] font-medium" data-id="element-709">My UniPlay Credits</p>
              <p className="text-sm text-[#3dc7e3] font-bold" data-id="element-710">500 UC</p>
            </div>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-711" />
          </button>

          <button onClick={() => alert('Buy More Credits\n\nPackages:\n• 100 UC - $10\n• 500 UC - $45 (10% bonus)\n• 1000 UC - $85 (15% bonus)\n\nPurchase credits to enjoy faster bookings and exclusive discounts!')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-712">
            <div className="w-5 h-5 flex items-center justify-center text-[#3dc7e3] text-xl font-bold" data-id="element-713">
              +
            </div>
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-714">
              Buy More Credits
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-715" />
          </button>

          <button onClick={() => alert('Transaction History\n\nRecent Transactions:\n• Nov 20: Court 1 booking - 15 UC\n• Nov 18: Credits purchased - +500 UC\n• Nov 15: Court 5 booking - 15 UC\n\nView full history in app.')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-716">
            <FileTextIcon className="w-5 h-5 text-[#666666]" data-id="element-717" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-718">
              Transaction History
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-719" />
          </button>
        </div>

        {/* Support section */}
        <div className="space-y-2" data-id="element-720">
          <h3 className="text-sm font-bold text-[#666666] px-2 mb-2" data-id="element-721">
            SUPPORT
          </h3>

          <button onClick={() => alert('Help Center\n\nFrequently Asked Questions:\n• How to book a court?\n• How to use UniPlay Credits?\n• Cancellation policy\n• Contact support\n\nEmail: support@pickleballbrunei.com\nPhone: +673 123 4567')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-722">
            <HelpCircleIcon className="w-5 h-5 text-[#666666]" data-id="element-723" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-724">
              Help Center
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-725" />
          </button>

          <button onClick={() => navigate('/promotion')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-726">
            <GiftIcon className="w-5 h-5 text-[#c7f61e]" data-id="element-727" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-728">
              Promotions
            </span>
            <span className="bg-[#E53935] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-729">
              2 NEW
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-730" />
          </button>

          <button onClick={() => alert('Terms & Privacy\n\nTerms of Service\nPrivacy Policy\nCancellation Policy\nRefund Policy\n\nLast updated: November 2024\n\nFor full details, visit our website.')} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-3 active:scale-98 transition-transform" data-id="element-731">
            <FileTextIcon className="w-5 h-5 text-[#666666]" data-id="element-732" />
            <span className="flex-1 text-left text-[#1f5070] font-medium" data-id="element-733">
              Terms & Privacy
            </span>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-734" />
          </button>
        </div>

        {/* Log out button */}
        <div className="pt-4 pb-2" data-id="element-735">
          <Button variant="outline" fullWidth onClick={handleLogout} className="!text-[#E53935] !border-[#E53935] hover:!bg-[#E53935]/5" data-id="element-736">
            <div className="flex items-center justify-center gap-2" data-id="element-737">
              <LogOutIcon className="w-5 h-5" data-id="element-738" />
              <span data-id="element-739">Log Out</span>
            </div>
          </Button>
        </div>
      </div>

      {/* Edit Profile Modal */}
      {showEditProfile && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-740">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full animate-scale-in" data-id="element-741">
            <h3 className="text-xl font-bold text-[#1f5070] mb-4" data-id="element-742">
              Edit Profile
            </h3>
            <div className="space-y-4 mb-6" data-id="element-743">
              <div data-id="element-744">
                <label className="text-sm font-medium text-[#666666] mb-1 block" data-id="element-745">
                  Name
                </label>
                <input type="text" defaultValue="Jabbar" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#3dc7e3]" data-id="element-746" />
              </div>
              <div data-id="element-747">
                <label className="text-sm font-medium text-[#666666] mb-1 block" data-id="element-748">
                  Email
                </label>
                <input type="email" defaultValue="jabbar@jwventures.group" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#3dc7e3]" data-id="element-749" />
              </div>
            </div>
            <div className="flex gap-3" data-id="element-750">
              <Button variant="secondary" fullWidth onClick={() => setShowEditProfile(false)} data-id="element-751">
                Cancel
              </Button>
              <Button variant="primary" fullWidth onClick={() => {
            setShowEditProfile(false);
            alert('Profile updated successfully!');
          }} data-id="element-752">
                Save
              </Button>
            </div>
          </div>
        </div>}

      {/* Language Modal */}
      {showLanguageModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-753">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full animate-scale-in" data-id="element-754">
            <h3 className="text-xl font-bold text-[#1f5070] mb-4" data-id="element-755">
              Select Language
            </h3>
            <div className="space-y-2 mb-6" data-id="element-756">
              {['English', 'Malay', '中文 (Chinese)'].map(lang => <button key={lang} onClick={() => {
            setShowLanguageModal(false);
            alert(`Language changed to ${lang}`);
          }} className="w-full p-3 text-left rounded-lg hover:bg-gray-100 active:scale-98 transition-all" data-id="element-757">
                  <span className="text-[#1f5070] font-medium" data-id="element-758">{lang}</span>
                  {lang === 'English' && <span className="ml-2 text-xs text-[#3dc7e3]" data-id="element-759">
                      ✓ Current
                    </span>}
                </button>)}
            </div>
            <Button variant="secondary" fullWidth onClick={() => setShowLanguageModal(false)} data-id="element-760">
              Cancel
            </Button>
          </div>
        </div>}

      <BottomNav data-id="element-761" />
    </div>;
}